import React from 'react';

import { IconName } from '@fortawesome/fontawesome-svg-core';
import styled from 'styled-components';

import Icon from '@/ui/components/Icon';

export const colorMap: Record<string, string> = {
  red: '#AA0A3C',
  orange: '#ff9024',
  yellow: '#f3e00e',
  green: '#16dc81',
  light_blue: '#15a1d6',
  blue: '#2343e8',
  violet: '#dc54b7',
  black: 'black',
};

type ColorBulletProps = {
  $color: string;
  $relative?: boolean;
};

export const ColorBullet = styled.span<ColorBulletProps>`
  display: block;
  position: ${props => (props.$relative ? 'relative' : 'absolute')};
  ${props => props.$relative && 'cursor: pointer;'};
  width: 12px;
  height: 12px;
  color: ${props => colorMap[props.$color]};
  text-align: center;
  border-radius: 50%;
  ${props => !props.$relative && 'left: 5px; top: 1px;'}
  font-size: 1.5rem;
  line-height: 1rem;

  @media print {
    top: 0.5em;
  }
`;

type IconWrapperProps = {
  $color?: string;
  $relative?: boolean;
};

export const IconWrapper = styled.span<IconWrapperProps>`
  ${props => !props.$relative && 'left: 0; top: 0;'}
  display: block;
  width: 24px;
  text-align: center;
  position: ${props => (props.$relative ? 'relative' : 'absolute')};
  ${props => props.$relative && 'cursor: pointer;'};
  color: ${props => props.$color || 'black'};

  svg {
    width: 24px;
  }

  @media print {
    top: 0.5em;
  }
`;

export const iconMap = {
  note: 'info-circle',
  caution: 'exclamation-triangle',
  reminder: 'thumbtack',
};

interface BulletProps {
  color?: string;
  icon?: keyof typeof iconMap;
  onClick?: () => void;
  relative?: boolean;
}

const Bullet: React.FC<BulletProps> = ({ color = 'black', icon, onClick, relative = false }) => {
  if (icon) {
    const faIcon = iconMap[icon] as IconName;

    return (
      <IconWrapper $color={icon === 'caution' ? 'red' : 'black'} onClick={onClick} $relative={relative}>
        <Icon name={faIcon} className={icon === 'caution' ? 'fa-beat' : ''} size="lg" />
      </IconWrapper>
    );
  }

  return (
    <ColorBullet $color={color} onClick={onClick} $relative={relative}>
      {'\u2B22'}
    </ColorBullet>
  );
};

export default Bullet;
